<template>
  <div
    class="container">
    <li
      class="collection-list-item"
      v-for="collection in sortedCollections"
      :key="collection.id">
      <div
        v-if="!hiddenCollections.includes(collection.id)"
        class="collection-list-item-div"
        :class="{
          'active-collection-list-item': collection.id === selectedCollection,
        }"
        :style="{ 'paddingLeft': `${indent(collection) * 1}rem`}"
        :ref="`item-${collection.id}`">
        <span
          class="icon icon-item"
          @click="toggleChildren(collection.id)">
          <i :class="getIconClass(collection.id)" />
        </span>
        <div
          class="collection-list-item-text"
          @click="clickedOn(collection.id)">
          {{ collection.name }}
        </div>
      </div>

      <!-- CHILDREN -->
      <ul
        class="sub"
        :class="{ 'sub-active': expandedCollections.includes(collection.id) }">
        <CollectionsList
          :collections="collection.children"
          :isRoot="false"
          @clicked-on="clickedOn"
          :selectedCollection="selectedCollection" />
      </ul>
    </li>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'CollectionsList',
  props: {
    collections: {
      type: Array,
      required: false,
    },
    isRoot: {
      type: Boolean,
      default: true,
    },
    selectedCollection: {
      type: Number,
    },
  },
  data() {
    return {
      selectedCollectionInList: null,
    };
  },
  computed: {
    ...mapState({
      collectionNodes: state => state.collections.collectionNodes,
      hiddenCollections: state => state.users.settings.hiddenCollections,
      expandedCollections: state => state.appState.expandedCollectionsInCollectionsList,
    }),
    collectionsToDisplay() {
      if (this.isRoot) return (this.collectionNodes && this.collectionNodes['0'].children) || [];
      return this.collections;
    },
    sortedCollections() {
      const collectionsToSort = this.collectionsToDisplay.slice();
      const sorted = collectionsToSort.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return sorted;
    },
  },
  methods: {
    ...mapMutations({
      ToggleExpandCollection: 'appState/ToggleExpandCollectionInCollectionList',
      ResetExpandedCollections: 'appState/ResetExpandedCollectionsInCollectionList',
    }),
    indent(collection) {
      let indent = 0;
      let currentlyChecking = collection;
      while (currentlyChecking.parent.id !== 0) {
        indent += 1;
        currentlyChecking = currentlyChecking.parent;
      }
      return indent;
    },
    toggleChildren(collectionId) {
      if (!this.collectionNodes[collectionId].children.length) return;

      this.ToggleExpandCollection(collectionId);
    },
    getIconClass(collectionId) {
      const hasChildren = !!this.collectionNodes[collectionId].children.length;
      const showsChildren = this.expandedCollections.includes(collectionId);

      return {
        'mdi mdi-menu-up': hasChildren && showsChildren,
        'mdi mdi-menu-down': hasChildren && !showsChildren,
        '': !hasChildren,
      };
    },
    clickedOn(collectionId) {
      if (this.selectedCollection === collectionId) this.toggleChildren(collectionId);
      else this.$emit('clicked-on', collectionId);
    },
  },
  beforeDestroy() {
    if (this.isRoot) this.ResetExpandedCollections();
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.collection-list-item {
  position: relative;
  background: inherit;
}
ul, li {
  list-style: none;
  font-weight: 300;
  position: relative;
  user-select: none;
}
.selected-collection-list-item,
.active-collection-list-item {
  background-color: $primary;
}
.sub {
  height: 0px;
  overflow: hidden;
  position: relative;
  padding-left: 0rem;
  margin: 0;
  list-style: none;
  flex-grow: 1;
}
.sub-active {
  height: auto;
}
.collection-list-item-div {
  cursor: pointer;
  display: flex;
  padding: 0.125rem 0;
}
.collection-list-item-text {
  flex-grow: 1;
  font-family: $headerFont;
  padding-left: 0.25rem;
  padding-top: 0.15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.collection-list-item-div:hover .icon-item {
  opacity: 1;
}
.icon-item {
  opacity: 0.4;
  padding-top: 0.125rem;
}
.icon {
  height: 100%;
  width: 1rem;
  cursor: pointer;
  color: $black;
  transition: all 0.2s;
}
</style>
